import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../../app/providers/AuthProvider";
import LoadingSpinner from "../../../shared/ui/LoadingSpinner";

export default function RequireAuth({ children }) {
  const { loading, isAuthenticated } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
